import React from 'react';
import { FormattedMessage, FormattedPlural } from 'react-intl';

interface DaysOutputProps {
  value?: number;
}

const DaysOutput: React.FC<DaysOutputProps> = ({ value }: DaysOutputProps) => (
  <>
    {value}&nbsp;
    <FormattedPlural
      value={value || 0}
      other={<FormattedMessage id="common.components.days.other" />}
      one={<FormattedMessage id="common.components.days.one" />}
      zero={<FormattedMessage id="common.components.days.zero" />}
      two={<FormattedMessage id="common.components.days.two" />}
      few={<FormattedMessage id="common.components.days.few" />}
      many={<FormattedMessage id="common.components.days.many" />}
    />
  </>
);

export default DaysOutput;
